// icons.js
import { ReactComponent as AddIcon } from "../../../../icons/icon_files/add_24.svg";
import { ReactComponent as CollapseCommentIcon } from "../../../../icons/icon_files/collapse_comment_24.svg";
import { ReactComponent as diamondIcon } from "../../../../icons/icon_files/Diamond.svg";
import { ReactComponent as ExpandCommentIcon } from "../../../../icons/icon_files/expand_comment_24.svg";
import { ReactComponent as adminUsersIcon } from "./admin_users.svg";
import { ReactComponent as appIcon } from "./appIcon.svg";
import { ReactComponent as AssigneeIcon } from "./Assign.svg";
import { ReactComponent as autoFixIcon } from "./auto-fix-icon.svg";
import { ReactComponent as backupIcon } from "./backup.svg";
import { ReactComponent as campaignIcon } from "./campaign.svg";
import { ReactComponent as chevronDownIcon } from "./chevron-down.svg";
import { ReactComponent as chevronLeftIcon } from "./chevron-left.svg";
import { ReactComponent as chevronRightIcon } from "./chevron-right.svg";
import { ReactComponent as clusterIcon } from "./cluster.svg";
import { ReactComponent as connectedHostsIcon } from "./connected_hosts.svg";
import { ReactComponent as connectedUserIcon } from "./connected_user.svg";
import { ReactComponent as criticalAssetIcon } from "./criticalAsset.svg";
import { ReactComponent as cveIcon } from "./cve_icons/cve.svg";
import { ReactComponent as cvesIcon } from "./cve_icons/cves.svg";
import { ReactComponent as DeleteBinIcon } from "./delete-bin.svg";
import { ReactComponent as departmentIcon } from "./departmentIcon.svg";
import { ReactComponent as DragIcon } from "./drag.svg";
import { ReactComponent as encryptionIcon } from "./encryption.svg";
import { ReactComponent as evidenceIcon } from "./evidence_icon.svg";
import { ReactComponent as executionIcon } from "./execution.svg";
import { ReactComponent as exploitInTheWildIcon } from "./exploit_in_the_wild.svg";
import { ReactComponent as FileCodeIcon } from "./file-code.svg";
import { ReactComponent as gapsIcon } from "./gaps.svg";
import { ReactComponent as groupsIcon } from "./groups.svg";
import { ReactComponent as historyIcon } from "./history.svg";
import { ReactComponent as activationDateIcon } from "./icon_activation_date_24.svg";
import { ReactComponent as activityIcon } from "./icon_activity_24.svg";
import { ReactComponent as aliasIcon } from "./icon_anonymous_24.svg";
import { ReactComponent as authenticationIcon } from "./icon_authentication_24.svg";
import { ReactComponent as expirationDateIcon } from "./icon_auto_stop_timeout_24.svg";
import { ReactComponent as certificateIssuerIcon } from "./icon_certificate_issuer_24.svg";
import { ReactComponent as certificateSubjectIcon } from "./icon_certificate_subject_24.svg";
import { ReactComponent as databaseIcon } from "./icon_database_24.svg";
import { ReactComponent as firewallIcon } from "./icon_firewall_24.svg";
import { ReactComponent as keyOriginIcon } from "./icon_key_24.svg";
import { ReactComponent as managedByIcon } from "./icon_managed_by_24.svg";
import { ReactComponent as readOnlyIcon } from "./icon_read_only_24.svg";
import { ReactComponent as securityGroupsIcon } from "./icon_security_groups.svg";
import { ReactComponent as variableIcon } from "./icon_variable_24.svg";
import { ReactComponent as internetFacingIcon } from "./internetFacing.svg";
import { ReactComponent as ipIcon } from "./ip.svg";
import { ReactComponent as jsonIcon } from "./json.svg";
import {
  ReactComponent as lastSeenIcon,
  ReactComponent as visibilityIcon,
} from "./last_seen.svg";
import { ReactComponent as CatoLogo } from "./logos/Cato.svg";
import { ReactComponent as OpenVPNLogo } from "./logos/OpenVPN.svg";
import { ReactComponent as mfaIcon } from "./MFA.svg";
import { ReactComponent as missingInformationIcon } from "./missing_information.svg";
import { ReactComponent as phishingDetectedIcon } from "./phishing_detected.svg";
import { ReactComponent as pinDefaultIcon } from "./pin-default.svg";
import { ReactComponent as pinSelectedIcon } from "./pin-selected.svg";
import { ReactComponent as recommendedConfiguration } from "./recommended_configuration.svg";
import { ReactComponent as SaveIcon } from "./save_icon.svg";
import { ReactComponent as UpdateIcon } from "./update_icon.svg";

import { ReactComponent as ExploitableIcon } from "../../../../icons/icon_files/exploitable.svg";
import { ReactComponent as ActionDownloadIcon } from "./action-download.svg";
import { ReactComponent as LockIcon } from "./action-lock.svg";
import { ReactComponent as SearchIcon } from "./action-search.svg";
import { ReactComponent as ResolveIcon } from "./action_icons/action-resolve-24.svg";
import {
  ReactComponent as collapseInbox,
  ReactComponent as SortIcon,
} from "./action_icons/actions-collapse-inbox-enabled-24.svg";
import { ReactComponent as DeleteIcon } from "./action_icons/actions-delete-bin2-enabled-24.svg";
import { ReactComponent as ExternalLinkCurrentColorIcon } from "./action_icons/actions-external-link-currentColor.svg";
import { ReactComponent as ExternalLinkIcon } from "./action_icons/actions-external-link-enabled-24.svg";
import { ReactComponent as LinkIcon } from "./action_icons/actions-link-enabled-24.svg";
import { ReactComponent as InboxAllNotificationIcon } from "./action_icons/actions-mark as resolved-enabled-24.svg";
import {
  ReactComponent as InboxUnreadIcon,
  ReactComponent as UnreadIcon,
} from "./action_icons/actions-mark-as-unread-enabled-24.svg";
import { ReactComponent as ExportIcon } from "./actions-export-enabled-24.svg";
import { ReactComponent as ScanIcon } from "./actions-scan-enabled-24.svg";
import { ReactComponent as SnoozedIcon } from "./actions-snooze-enabled-24.svg";
import { ReactComponent as UnsnoozedIcon } from "./actions-unsnooze-enabled-24.svg";
import { ReactComponent as arrowRightIcon } from "./arrow-right.svg";
import { ReactComponent as arrow } from "./arrow.svg";
import { ReactComponent as ArrowBackIcon } from "./arrow_back.svg";
import { ReactComponent as ArrowDownIcon } from "./arrow_icons/arrow-down-outline-24.svg";
import { ReactComponent as ArrowUpIcon } from "./arrow_icons/arrow-up-outline-24.svg";
import { ReactComponent as NewTabIcon } from "./new-tab.svg";
import { ReactComponent as UndoIcon } from "./undo_icon.svg";

import { ReactComponent as AssetAttackerIcon } from "./attacker_asset.svg";
import { ReactComponent as autoStopTimeoutIcon } from "./autoStopTimeout.svg";
import { ReactComponent as Unchecked } from "./checkbox-off.svg";
import { ReactComponent as Checked } from "./checkbox-on.svg";
import { ReactComponent as configIcon } from "./config.svg";
import { ReactComponent as createdIcon } from "./created.svg";
import { ReactComponent as creatorIcon } from "./creator.svg";
import { ReactComponent as CriticalAssetHexagon } from "./critical_asset_hexagon.svg";
import { ReactComponent as ExploitInTheWildOutline } from "./cve_icons/cve-exploit-in-the-wild-outline.svg";
import { ReactComponent as ExploitableOutline } from "./cve_icons/cve-exploitable-new-outline.svg";
import { ReactComponent as InternetFacing } from "./cve_icons/icons-default-internet-enabled-24.svg";
import { ReactComponent as deployedIcon } from "./deployed.svg";
import { ReactComponent as ExportCSVIcon } from "./Export_CSV.svg";
import { ReactComponent as ExportPDFIcon } from "./Export_PDF.svg";
import { ReactComponent as FirstWorkflowIcon } from "./first-workflow-icon.svg";
import { ReactComponent as AssetHexagon } from "./hexagon.svg";
import { ReactComponent as LocationHexagon } from "./hexagon_location.svg";
import { ReactComponent as MonitorIcon } from "./icon_monitor_24.svg";
import { ReactComponent as Indeterminate } from "./indeterminate.svg";
import { ReactComponent as MultiTenantIcon } from "./multi-tenant.svg";
import {
  ReactComponent as DisablePasswordRevealInOktaIcon,
  ReactComponent as RestrictFileAccessIcon,
  ReactComponent as RevokeTokenIcon,
} from "./revoke-token.svg";
import { ReactComponent as SingleTenantIcon } from "./single-tenant.svg";
import { ReactComponent as TimeframeIcon } from "./timeframe.svg";

import { ReactComponent as MagicWandIcon } from "../../../../icons/icon_files/magic_wand.svg";
import { ReactComponent as addTeamIcon } from "./add_team.svg";
import { ReactComponent as connectorIcon } from "./connector.svg";
import { ReactComponent as DeleteBinIcon2 } from "./delete-bin2.svg";
import { ReactComponent as DoneIcon } from "./done.svg";
import { ReactComponent as EditIcon2 } from "./edit2.svg";
import { ReactComponent as ExpandScreenIcon } from "./Expand.svg";
import { ReactComponent as favoritesIcon } from "./favorites.svg";
import { ReactComponent as catalogIcon } from "./icon_catalog_24.svg";
import { ReactComponent as containerIcon } from "./icon_container_24.svg";
import { ReactComponent as countIcon } from "./icon_count_24.svg";
import { ReactComponent as deviceModelIcon } from "./icon_device_model_24.svg";
import { ReactComponent as environmentIcon } from "./icon_environment_24.svg";
import { ReactComponent as githubSecretIcon } from "./icon_github_secret_24.svg";
import { ReactComponent as endpointsIcon } from "./icon_hosts_24.svg";
import { ReactComponent as organizationIcon } from "./icon_organization_24.svg";
import { ReactComponent as passwordChangedIcon } from "./icon_password_changed_24.svg";
import { ReactComponent as permissionsBoundaryIcon } from "./icon_permissions_boundary_24.svg";
import { ReactComponent as policyRoundedIcon } from "./icon_policy_rounded_24.svg";
import { ReactComponent as programmaticKeysIcon } from "./icon_programmatic_keys_24.svg";
import { ReactComponent as gitRepositoryIcon } from "./icon_repository_24.svg";
import { ReactComponent as secretScopeIcon } from "./icon_secret_scope_24.svg";
import { ReactComponent as serialNumberIcon } from "./icon_serial_number_24.svg";
import { ReactComponent as serverlessIcon } from "./icon_serverless_24.svg";
import { ReactComponent as serversIcon } from "./icon_servers_24.svg";
import { ReactComponent as supportIcon } from "./icon_support_24.svg";
import {
  ReactComponent as keyUsageTypeIcon,
  ReactComponent as serverTypeIcon,
  ReactComponent as typeIcon,
} from "./icon_type_24.svg";
import { ReactComponent as vaultIcon } from "./icon_vault_24.svg";
import { ReactComponent as LabelOutlineIcon } from "./label_outline.svg";
import { ReactComponent as LabelIcon } from "./labelIcon.svg";
import { ReactComponent as languagesIcon } from "./languages.svg";
import { ReactComponent as lastChangedIcon } from "./last_changed.svg";
import { ReactComponent as ManufacturerIcon } from "./manufacturer.svg";
import { ReactComponent as MenuVerticalIcon } from "./menu_vertical_icon.svg";
import { ReactComponent as networkIcon } from "./network.svg";
import { ReactComponent as openModalIcon } from "./openModal.svg";
import { ReactComponent as osVersionIcon } from "./os_version.svg";
import { ReactComponent as passwordTrackingIcon } from "./password_tracking.svg";
import { ReactComponent as policiesIcon } from "./policies.svg";
import { ReactComponent as projectIcon } from "./projectName.svg";
import { ReactComponent as propertiesIcon } from "./properties.svg";
import { ReactComponent as publicIcon } from "./public.svg";
import { ReactComponent as PurchaseIcon } from "./purchase.svg";
import { ReactComponent as questionMarkIcon } from "./question_mark.svg";
import { ReactComponent as regionServerIcon } from "./region_server.svg";
import { ReactComponent as repositoryIcon } from "./repository.svg";
import { ReactComponent as riskIcon } from "./risk.svg";
import { ReactComponent as rolesIcon } from "./roles.svg";
import { ReactComponent as severityIcon } from "./severity.svg";
import { ReactComponent as severityLowIcon } from "./severityLow.svg";
import { ReactComponent as signInIcon } from "./sign_in.svg";
import { ReactComponent as siteIcon } from "./siteIcon.svg";
import { ReactComponent as statusIcon } from "./status.svg";
import { ReactComponent as stepsIcon } from "./steps.svg";
import { ReactComponent as TagIcon } from "./tag_icon.svg";
import { ReactComponent as tagsIcon } from "./tags.svg";
import { ReactComponent as terminationIcon } from "./termination.svg";
import { ReactComponent as threatActorIcon } from "./threatActor.svg";
import { ReactComponent as threatTypeIcon } from "./threatType.svg";
import { ReactComponent as ToggleIcon } from "./toggle.svg";
import { ReactComponent as userIcon } from "./user.svg";
// asset icons
import { ReactComponent as DomainControllerIcon } from "./asset_icon/assets-domain-controller.svg";
import { ReactComponent as EndpointIcon } from "./asset_icon/assets-endpoint-24.svg";
import { ReactComponent as EntitiesIcon } from "./asset_icon/assets-entities-24.svg";
import { ReactComponent as ExternalApplication16 } from "./asset_icon/assets-externalapp-24.svg";
import { ReactComponent as InternalApplication16 } from "./asset_icon/assets-internalapp-24.svg";
import { ReactComponent as KeyPeople16 } from "./asset_icon/assets-key-people-24.svg";
import { ReactComponent as SensitiveData16 } from "./asset_icon/assets-sensitive-data-24.svg";
import { ReactComponent as AssetsServerIcon } from "./asset_icon/Assets_Server_24.svg";
import { ReactComponent as AssetsUserIcon } from "./asset_icon/Assets_User_24.svg";
import { ReactComponent as DefaultAssetIcon } from "./critical-asset-outlined.svg";
import { ReactComponent as AssetsBlueIcon } from "./critical_asset_outlined_blue.svg";
import { ReactComponent as FilterIcon } from "./filter_icon_24.svg";
import { ReactComponent as RandomWorkflowIcon } from "./random.svg";

//display modes
import { ReactComponent as CardIcon } from "./card_view_24.svg";
import { ReactComponent as TableIcon } from "./table_view_24.svg";

// detection icons
import { ReactComponent as DetectionBlack } from "./detection_icons/threat-detected-24-detections-black.svg";
import { ReactComponent as DetectionRed } from "./detection_icons/threat-detected-24-detections-error.svg";

//  logos
import { ReactComponent as LinuxIcon } from "./linux.svg";
import { ReactComponent as AbnormalLogo } from "./logos/Abnormal.svg";
import { ReactComponent as AddigyLogo } from "./logos/Addigy.svg";
import { ReactComponent as AdobeLogo } from "./logos/Adobe.svg";
import { ReactComponent as AkamaiWAFLogo } from "./logos/AkamaiWAF.svg";
import { ReactComponent as AMILogo } from "./logos/AMI.svg";
import { ReactComponent as AsanaLogo } from "./logos/Asana.svg";
import { ReactComponent as AWSLogo } from "./logos/aws.svg";
import { ReactComponent as AxurLogo } from "./logos/Axur.svg";
import { ReactComponent as MicrosoftAzureCloudLogo } from "./logos/Azure.svg";
import { ReactComponent as AzureSqlDBLogo } from "./logos/AzureSqlDB.svg";
import { ReactComponent as AzureVMLogo } from "./logos/AzureVM.svg";
import { ReactComponent as BambooHRLogo } from "./logos/BambooHR.svg";
import { ReactComponent as BitwardenLogo } from "./logos/Bitwarden.svg";
import { ReactComponent as BoxLogo } from "./logos/Box.svg";
import { ReactComponent as BreezeLogo } from "./logos/breeze-24.svg";
import { ReactComponent as CarbonBlackLogo } from "./logos/Carbonblack.svg";
import { ReactComponent as ChatGptLogo } from "./logos/ChatGPT.svg";
import { ReactComponent as CheckmarxLogo } from "./logos/Checkmarx.svg";
import { ReactComponent as CheckpointHarmonyLogo } from "./logos/CheckpointHarmony.svg";
import { ReactComponent as CheckpointQuantumLogo } from "./logos/CheckpointQuantum.svg";
import { ReactComponent as CircleCILogo } from "./logos/CircleCI.svg";
import { ReactComponent as ClaudeLogo } from "./logos/Claude24.svg";
import { ReactComponent as CloudflareLogo } from "./logos/Cloudflare.svg";
import { ReactComponent as CoralogixLogo } from "./logos/Coralogix.svg";
import { ReactComponent as PaloAltoCortexLogo } from "./logos/Cortex.svg";
import { ReactComponent as CrowdStrikeLogo } from "./logos/CrowdStrike.svg";
import { ReactComponent as CursorLogo } from "./logos/Cursor24.svg";
import { ReactComponent as CyberArkLogo } from "./logos/CyberArk.svg";
import { ReactComponent as DeepSeekLogo } from "./logos/Deepseek.svg";
import { ReactComponent as DigLogo } from "./logos/Dig.svg";
import { ReactComponent as DocusignLogo } from "./logos/Docusign.svg";
import { ReactComponent as DynamodbLogo } from "./logos/DynamoDB.svg";
import { ReactComponent as EC2Logo } from "./logos/EC2.svg";
import { ReactComponent as ECSLogo } from "./logos/ECS.svg";
import { ReactComponent as EKSLogo } from "./logos/EKS.svg";
import { ReactComponent as ESCLogo } from "./logos/ESC.svg";
import { ReactComponent as FigmaLogo } from "./logos/Figma.svg";
import { ReactComponent as FortinetLogo } from "./logos/Fortinet.svg";
import { ReactComponent as GCPLogo } from "./logos/gcp.svg";
import { ReactComponent as GeminiLogo } from "./logos/Gemini.svg";
import { ReactComponent as GitHubLogo } from "./logos/Github.svg";
import { ReactComponent as GitLabLogo } from "./logos/GitLab.svg";
import { ReactComponent as GoogleLogo } from "./logos/Google.svg";
import { ReactComponent as GreenhouseLogo } from "./logos/Greenhouse.svg";
import { ReactComponent as HiBobLogo } from "./logos/HiBob.svg";
import { ReactComponent as HubspotLogo } from "./logos/Hubspot.svg";
import { ReactComponent as ImpervaWAFLogo } from "./logos/ImpervaWAF.svg";
import { ReactComponent as IntuneLogo } from "./logos/Intune.svg";
import { ReactComponent as IruLogo } from "./logos/Iru.svg";
import { ReactComponent as JamfLogo } from "./logos/Jamf.svg";
import { ReactComponent as JamfProtectLogo } from "./logos/JamfProtect.svg";
import { ReactComponent as JiraLogo } from "./logos/Jira.svg";
import { ReactComponent as LambdaLogo } from "./logos/Lambda.svg";
import { ReactComponent as LayerXLogo } from "./logos/LayerX.svg";
import { ReactComponent as MicrosoftActiveDirectoryLogo } from "./logos/MicrosoftActiveDirectory.svg";
import { ReactComponent as MicrosoftDefenderEndpoint } from "./logos/MicrosoftDefenderEndpoint.svg";
import { ReactComponent as MicrosoftEntraIDLogo } from "./logos/MicrosoftEntraID.svg";
import { ReactComponent as MicrosoftOffice365Logo } from "./logos/MicrosoftOffice365.svg";
import { ReactComponent as MicrosoftSCCMLogo } from "./logos/MicrosoftSCCM.svg";
import { ReactComponent as MicrosoftTeamsLogo } from "./logos/MicrosoftTeams.svg";
import { ReactComponent as MimecastLogo } from "./logos/Mimecast.svg";
import { ReactComponent as MiroLogo } from "./logos/Miro.svg";
import { ReactComponent as MondayLogo } from "./logos/Monday.svg";
import { ReactComponent as MongoAtlasLogo } from "./logos/Mongo.svg";
import { ReactComponent as NetskopeLogo } from "./logos/Netskope.svg";
import { ReactComponent as NetsuiteLogo } from "./logos/Netsuite.svg"; //the old logo
import { ReactComponent as NotionLogo } from "./logos/Notion.svg";
import { ReactComponent as OktaLogo } from "./logos/Okta.svg";
import { ReactComponent as OneTrustLogo } from "./logos/OneTrust.svg";
import { ReactComponent as OpenAILogo } from "./logos/OpenAI24.svg";
import { ReactComponent as OrcaLogo } from "./logos/Orca.svg";
import { ReactComponent as OxLogo } from "./logos/Ox.svg";
import { ReactComponent as PaloAltoPrismaLogo } from "./logos/PaloAlto.svg";
import { ReactComponent as PanoraysLogo } from "./logos/Panorays.svg";
import { ReactComponent as PerceptionPoint } from "./logos/PP.svg";
import { ReactComponent as PrismaAccessBrowserLogo } from "./logos/prismaAccessBrowser.svg";
import { ReactComponent as ProofpointLogo } from "./logos/Proofpoint.svg";
import { ReactComponent as QualysLogo } from "./logos/Qualys.svg";
import { ReactComponent as Rapid7Logo } from "./logos/Rapid7.svg";
import { ReactComponent as RDSLogo } from "./logos/RDS.svg";
import { ReactComponent as S3Logo } from "./logos/S3.svg";
import { ReactComponent as SalesForceLogo } from "./logos/Salesforce.svg";
import { ReactComponent as SecurityScorecard } from "./logos/securityScorecard.svg";
import { ReactComponent as SentraLogo } from "./logos/Sentra.svg";
import { ReactComponent as SilverfortLogo } from "./logos/Silverfort.svg";
import { ReactComponent as SplunkCloudLogo } from "./logos/Splunk.svg";
import { ReactComponent as SumoLogicLogo } from "./logos/SumoLogic.svg";
import { ReactComponent as VaronisLogo } from "./logos/Varonis.svg";
import { ReactComponent as VeeamLogo } from "./logos/Veeam.svg";
import { ReactComponent as WorkspaceLogo } from "./logos/Workspace.svg";
import { ReactComponent as ZendeskLogo } from "./logos/Zendesk.svg";
import { ReactComponent as ZoomLogo } from "./logos/Zoom.svg";
import { ReactComponent as NetwareIcon } from "./Netware.svg";
import { ReactComponent as RedhatIcon } from "./Redhat.svg";

import { ReactComponent as CloseIcon } from "./close_icon.svg";
import { ReactComponent as BuildWorkflowIcon } from "./create_workflow.svg";
import {
  ReactComponent as consoleAccessIcon,
  ReactComponent as domainIcon,
} from "./domain.svg";
import { ReactComponent as AtlassianLogo } from "./logos/Atlassian.svg";
import { ReactComponent as JumpCloudLogo } from "./logos/jumpcloud.svg";
import { ReactComponent as NinjaOneLogo } from "./logos/NinjaOne.svg";
import { ReactComponent as NISTLogo } from "./logos/NISTLogo.svg";
import { ReactComponent as SentinelOneLogo } from "./logos/SentinelOne.svg";
import { ReactComponent as ServiceNowLogo } from "./logos/ServiceNow.svg";
import { ReactComponent as SlackLogo } from "./logos/Slack.svg";
import { ReactComponent as SnowflakeLogo } from "./logos/Snowflake.svg";
import { ReactComponent as SnykLogo } from "./logos/Snyk.svg";
import { ReactComponent as StarburstLogo } from "./logos/Starburst.svg";
import { ReactComponent as TenableLogo } from "./logos/Tenable.svg";
import { ReactComponent as TorqLogo } from "./logos/Torq.svg";
import { ReactComponent as TwingateLogo } from "./logos/Twingate.svg";
import { ReactComponent as WizLogo } from "./logos/Wiz.svg";
import { ReactComponent as WorkatoLogo } from "./logos/Workato.svg";
import { ReactComponent as ZscalerLogo } from "./logos/Zscaler.svg";
import { ReactComponent as MacIcon } from "./mac.svg";
import { ReactComponent as MobileIcon } from "./mobile.svg";
import { ReactComponent as WindowsIcon } from "./windows.svg";

//severities
import { ReactComponent as SeverityErrorIcon } from "./severity_icons/severity-icons-background-error-24.svg";
import { ReactComponent as SeverityBackgroundInfoIcon } from "./severity_icons/severity-icons-background-info-24.svg";
import { ReactComponent as SeverityBackgroundSuccessIcon } from "./severity_icons/severity-icons-background-success-24.svg";
import { ReactComponent as SeverityBackgroundWarningIcon } from "./severity_icons/severity-icons-background-warning-24.svg";
import { ReactComponent as SeverityWarningType2Icon } from "./severity_icons/severity-icons-background-warning-type-2-24.svg";
import { ReactComponent as SeverityBlackIcon } from "./severity_icons/severity-icons-black-24.svg";
import { ReactComponent as OutlineSeverity } from "./severity_icons/severity-icons-black-outline-24.svg";
import { ReactComponent as SeverityBlueIcon } from "./severity_icons/severity-icons-blue-24.svg";
import { ReactComponent as CriticalSeverityIcon } from "./severity_icons/severity-icons-critical-24.svg";
import { ReactComponent as HighSeverityIcon } from "./severity_icons/severity-icons-high-24.svg";
import { ReactComponent as SeverityInfoTooltipIcon } from "./severity_icons/severity-icons-info-tooltip-24.svg";
import { ReactComponent as LowSeverityIcon } from "./severity_icons/severity-icons-low-24.svg";
import { ReactComponent as MediumSeverityIcon } from "./severity_icons/severity-icons-medium-24.svg";
import { ReactComponent as MinimalSeverityIcon } from "./severity_icons/severity-icons-minimal-24.svg";
import { ReactComponent as SeveritySuccessIcon } from "./severity_icons/severity-icons-success-24.svg";

//jira priority icons
import { ReactComponent as HighIcon } from "./jira_priority_icons/jira-priority-arrow-high.svg";
import { ReactComponent as HighestIcon } from "./jira_priority_icons/jira-priority-arrow-highest.svg";
import { ReactComponent as LowIcon } from "./jira_priority_icons/jira-priority-arrow-low.svg";
import { ReactComponent as LowestIcon } from "./jira_priority_icons/jira-priority-arrow-lowest.svg";
import { ReactComponent as MediumIcon } from "./jira_priority_icons/jira-priority-arrow-medium.svg";
import { ReactComponent as TriageIcon } from "./jira_priority_icons/jira-priority-arrow-triage.svg";

// sidebar icons
import { ReactComponent as LogoCollapsed } from "./sidebar_icons/side-bar-logo-collapsed.svg";
import { ReactComponent as LogoExpanded } from "./sidebar_icons/side-bar-logo-expanded.svg";
import {
  ReactComponent as AdminPermissionsIcon,
  ReactComponent as UserPermissionsIcon,
} from "./sidebar_icons/sidebar-icon-admin-permissions.svg";
import { ReactComponent as AIIcon } from "./sidebar_icons/sidebar-icons-ai.svg";
import { ReactComponent as StepsIcon } from "./sidebar_icons/sidebar-icons-attack-steps.svg";
import { ReactComponent as ScenariosIcon } from "./sidebar_icons/sidebar-icons-attack-surface2.svg";
import { ReactComponent as AutomationIcon } from "./sidebar_icons/sidebar-icons-automation.svg";
import { ReactComponent as AccountCenterIcon } from "./sidebar_icons/sidebar-icons-avatar.svg";
import { ReactComponent as CloudIcon } from "./sidebar_icons/sidebar-icons-cloud.svg";
import { ReactComponent as CollapseIcon } from "./sidebar_icons/sidebar-icons-collapse.svg";
import { ReactComponent as ControlsIcon } from "./sidebar_icons/sidebar-icons-controls.svg";
import { ReactComponent as AssetsIcon } from "./sidebar_icons/sidebar-icons-critical-asset.svg";
import { ReactComponent as DashboardIcon } from "./sidebar_icons/sidebar-icons-dashboard.svg";
import { ReactComponent as EnvironmentIcon } from "./sidebar_icons/sidebar-icons-environment.svg";
import { ReactComponent as ExpandIcon } from "./sidebar_icons/sidebar-icons-expand.svg";
import { ReactComponent as FrameworkIcon } from "./sidebar_icons/sidebar-icons-frameworks.svg";
import { ReactComponent as InboxIcon } from "./sidebar_icons/sidebar-icons-inbox.svg";
import { ReactComponent as IntegrationsIcon } from "./sidebar_icons/sidebar-icons-integrations.svg";
import { ReactComponent as MatrixIcon } from "./sidebar_icons/sidebar-icons-matrix.svg";
import { ReactComponent as MitreIcon } from "./sidebar_icons/sidebar-icons-mitre.svg";
import { ReactComponent as NotificationsIcon } from "./sidebar_icons/sidebar-icons-notifications.svg";
import { ReactComponent as OktaSSOIcon } from "./sidebar_icons/sidebar-icons-okta-SSO.svg";
import { ReactComponent as PlaybookIcon } from "./sidebar_icons/sidebar-icons-playbook.svg";
import { ReactComponent as RemediationPlanIcon } from "./sidebar_icons/sidebar-icons-remediation.svg";
import { ReactComponent as SecOpIcon } from "./sidebar_icons/sidebar-icons-secops.svg";
import {
  ReactComponent as SettingCenterIcon,
  ReactComponent as SettingsIcon,
} from "./sidebar_icons/sidebar-icons-settings.svg";

import { ReactComponent as TrackingIcon } from "./sidebar_icons/sidebar-icons-tracking.svg";
import { ReactComponent as UserAccessIcon } from "./sidebar_icons/sidebar-icons-user-access.svg";
import { ReactComponent as VulnerabilitiesIcon } from "./sidebar_icons/sidebar-icons-vulnerabilities.svg";
import { ReactComponent as WorkflowsIcon } from "./sidebar_icons/sidebar-icons-workflows.svg";
// operational heatmap icons
import { ReactComponent as RemoveCircleIcon } from "../../../../icons/icon_files/remove_circle_24.svg";
import { ReactComponent as CommvaultLogo } from "./logos/Commvault.svg";
import { ReactComponent as CyeraLogo } from "./logos/Cyera.svg";
import { ReactComponent as DruvaLogo } from "./logos/Druva.svg";
import { ReactComponent as RubrikLogo } from "./logos/Rubrik.svg";
import { ReactComponent as DevelopmentIcon } from "./operational_heatmap_icons/sub-pillars-apps-application developement.svg";
import { ReactComponent as EmailIcon } from "./operational_heatmap_icons/sub-pillars-apps-email and comms.svg";
import { ReactComponent as FileSharingIcon } from "./operational_heatmap_icons/sub-pillars-apps-file sharing.svg";
import { ReactComponent as ProductivityIcon } from "./operational_heatmap_icons/sub-pillars-apps-productivity tools.svg";
import { ReactComponent as ContainerIcon } from "./operational_heatmap_icons/sub-pillars-compute-container.svg";
import { ReactComponent as EdgeComputeIcon } from "./operational_heatmap_icons/sub-pillars-compute-edge compute.svg";
import { ReactComponent as ServerIcon } from "./operational_heatmap_icons/sub-pillars-compute-server.svg";
import { ReactComponent as ServerlessIcon } from "./operational_heatmap_icons/sub-pillars-compute-serverless.svg";
import { ReactComponent as AnalyticalDataStorageIcon } from "./operational_heatmap_icons/sub-pillars-datastores-analytical data storage.svg";
import { ReactComponent as StorageIcon } from "./operational_heatmap_icons/sub-pillars-datastores-cloud storage.svg";
import { ReactComponent as DatabaseIcon } from "./operational_heatmap_icons/sub-pillars-datastores-database.svg";
import { ReactComponent as IdentityIcon } from "./operational_heatmap_icons/sub-pillars-identity-idp.svg";
import { ReactComponent as ServiceAccountsIcon } from "./operational_heatmap_icons/sub-pillars-identity-service accounts.svg";
import { ReactComponent as ApiIcon } from "./operational_heatmap_icons/sub-pillars-identity-token.svg";
import { ReactComponent as SecretsIcon } from "./operational_heatmap_icons/sub-pillars-nhi-secrets.svg";

// input icons
import { ReactComponent as errorIcon } from "./input_icons/error.svg";
import { ReactComponent as infoIcon } from "./input_icons/info.svg";
import { ReactComponent as PrimaryInfoIcon } from "./input_icons/primary-info.svg";
import { ReactComponent as successIcon } from "./input_icons/success.svg";

// chart icons
import { ReactComponent as BarChartIcon } from "./chart_icons/bar_chart.svg";
import { ReactComponent as DonutChartIcon } from "./chart_icons/donut_chart.svg";
import { ReactComponent as GaugeChartIcon } from "./chart_icons/gauge_chart.svg";
import { ReactComponent as HeatmapChartIcon } from "./chart_icons/heatmap_chart.svg";
import { ReactComponent as TwoLineChartIcon } from "./chart_icons/line2_chart.svg";
import { ReactComponent as LineChartIcon } from "./chart_icons/line_chart.svg";
import { ReactComponent as MetricsChartIcon } from "./chart_icons/metrics_chart.svg";
import { ReactComponent as PieChartIcon } from "./chart_icons/pie_chart.svg";
import { ReactComponent as StackedBarChartIcon } from "./chart_icons/stacked_bar_chart.svg";
import { ReactComponent as TableChartIcon } from "./chart_icons/table_chart.svg";

// control colored dot icons
import { ReactComponent as ControlNotApplicableIcon } from "./control_not_applicable.svg";
import { ReactComponent as ControlStatusCompliantIcon } from "./control_status_compliant.svg";
import { ReactComponent as ControlStatusGapIcon } from "./control_status_gap.svg";

// control actions
import { ReactComponent as AddCircleIcon } from "../../../../icons/icon_files/add_circle_24.svg";
import { ReactComponent as AICategoryIcon } from "./controls-category/AI.svg";
import { ReactComponent as DLPCategoryIcon } from "./controls-category/Data-leakage.svg";
import { ReactComponent as EDRCategoryIcon } from "./controls-category/EDR.svg";
import { ReactComponent as EmailCategoryIcon } from "./controls-category/Email.svg";
import { ReactComponent as MFACategoryIcon } from "./controls-category/MFA.svg";
import { ReactComponent as NHIcategoryIcon } from "./controls-category/NHI.svg";
import { ReactComponent as ZeroTrustCategoryIcon } from "./controls-category/Zero-trust.svg";
import { ReactComponent as RemoveLinkIcon } from "./remove_link_24.svg";
import { ReactComponent as SetPriorityIcon } from "./set_priority_24.svg";
import { ReactComponent as SetSeverityIcon } from "./set_severity_24.svg";
import { ReactComponent as TrendDownIcon } from "./trend_down.svg";
import { ReactComponent as TrendUpIcon } from "./trend_up.svg";

//workflows conditions
import { ReactComponent as WorkflowIfIcon } from "./workflows_icons/workflows-if.svg";
import { ReactComponent as WorkflowThenIcon } from "./workflows_icons/workflows-then.svg";
import { ReactComponent as WorkflowWhenIcon } from "./workflows_icons/workflows-when.svg";

// empty data icon
import { ReactComponent as CloudErrorIcon } from "./CloudError.svg";
import { ReactComponent as EmptyPostureTrendIcon } from "./empty_posture_trend.svg";
import { ReactComponent as NoResultsIcon } from "./no_results.svg";
import { ReactComponent as EmptyResultsIcon } from "./NoResults.svg";
import { ReactComponent as EmptyAIIntegrationsIcon } from "./not_connected_icon.svg";

export const icons = {
  AddIcon,
  adminUsersIcon,
  connectedHostsIcon,
  cveIcon,
  groupsIcon,
  historyIcon,
  mfaIcon,
  passwordTrackingIcon,
  policiesIcon,
  propertiesIcon,
  riskIcon,
  rolesIcon,
  tagsIcon,
  TagIcon,
  creatorIcon,
  publicIcon,
  lastChangedIcon,
  repositoryIcon,
  createdIcon,
  autoStopTimeoutIcon,
  deployedIcon,
  languagesIcon,
  ipIcon,
  serialNumberIcon,
  deviceModelIcon,
  osVersionIcon,
  statusIcon,
  departmentIcon,
  diamondIcon,
  lastSeenIcon,
  siteIcon,
  connectedUserIcon,
  serverTypeIcon,
  regionServerIcon,
  encryptionIcon,
  backupIcon,
  expirationDateIcon,
  activationDateIcon,
  stepsIcon,
  gapsIcon,
  networkIcon,
  terminationIcon,
  openModalIcon,
  threatActorIcon,
  threatTypeIcon,
  cvesIcon,
  campaignIcon,
  criticalAssetIcon,
  executionIcon,
  internetFacingIcon,
  phishingDetectedIcon,
  clusterIcon,
  exploitInTheWildIcon,
  jsonIcon,
  missingInformationIcon,
  recommendedConfiguration,
  evidenceIcon,
  aliasIcon,
  managedByIcon,
  variableIcon,
  firewallIcon,
  keyOriginIcon,
  keyUsageTypeIcon,
  Unchecked,
  Checked,
  Indeterminate,
  configIcon,
  severityIcon,
  severityLowIcon,
  DefaultAssetIcon,
  TableIcon,
  CardIcon,
  domainIcon,
  signInIcon,
  appIcon,
  userIcon,
  permissionsBoundaryIcon,
  consoleAccessIcon,
  passwordChangedIcon,
  programmaticKeysIcon,
  policyRoundedIcon,
  ExploitInTheWildOutline,
  ExploitableOutline,
  InternetFacing,
  serverlessIcon,
  containerIcon,
  serversIcon,
  endpointsIcon,
  SnoozedIcon,
  UnsnoozedIcon,
  ScanIcon,
  ExportIcon,
  SearchIcon,
  LockIcon,
  ExploitableIcon,
  typeIcon,
  visibilityIcon,
  gitRepositoryIcon,
  environmentIcon,
  secretScopeIcon,
  githubSecretIcon,
  organizationIcon,
  collapseInbox,
  InboxUnreadIcon,
  InboxAllNotificationIcon,
  SortIcon,
  ArrowBackIcon,
  ArrowDownIcon,
  ArrowUpIcon,
  NewTabIcon,
  DeleteIcon,
  LinkIcon,
  UnreadIcon,
  IntegrationsIcon,
  vaultIcon,
  certificateSubjectIcon,
  certificateIssuerIcon,
  AssetAttackerIcon,
  AssetHexagon,
  LocationHexagon,
  CriticalAssetHexagon,
  arrow,
  arrowRightIcon,
  questionMarkIcon,
  MonitorIcon,
  chevronDownIcon,
  chevronRightIcon,
  chevronLeftIcon,
  pinDefaultIcon,
  pinSelectedIcon,
  MultiTenantIcon,
  SingleTenantIcon,
  DeleteBinIcon,
  projectIcon,
  RevokeTokenIcon,
  RestrictFileAccessIcon,
  DisablePasswordRevealInOktaIcon,
  autoFixIcon,
  ApiIcon,
  AssigneeIcon,
  ExportCSVIcon,
  ExportPDFIcon,
  ActionDownloadIcon,
  countIcon,
  databaseIcon,
  authenticationIcon,
  readOnlyIcon,
  catalogIcon,
  FileCodeIcon,
  RemoveCircleIcon,
  supportIcon,
  ExpandScreenIcon,
  NoResultsIcon,
  FirstWorkflowIcon,
  favoritesIcon,
  ExternalLinkIcon,
  ExternalLinkCurrentColorIcon,
  DragIcon,
  SettingsIcon,
  FilterIcon,
  DoneIcon,
  ManufacturerIcon,
  MenuVerticalIcon,
  DeleteBinIcon2,
  EditIcon2,
  ToggleIcon,
  CloseIcon,
  LabelIcon,
  LabelOutlineIcon,
  connectorIcon,
  UndoIcon,
  TimeframeIcon,
  ControlStatusGapIcon,
  ControlStatusCompliantIcon,
  ControlNotApplicableIcon,
  TrendUpIcon,
  TrendDownIcon,
  AddCircleIcon,
  SetSeverityIcon,
  RemoveLinkIcon,
  SetPriorityIcon,
  ExpandCommentIcon,
  CollapseCommentIcon,
  ResolveIcon,
  BuildWorkflowIcon,
  activityIcon,
  MagicWandIcon,
  PurchaseIcon,
  securityGroupsIcon,
  EmptyPostureTrendIcon,
  EmptyAIIntegrationsIcon,
  addTeamIcon,
  SaveIcon,
  UpdateIcon,
};

export const emptyStateIcons = {
  NoResultsIcon,
  EmptyPostureTrendIcon,
  EmptyAIIntegrationsIcon,
  CloudErrorIcon,
  EmptyResultsIcon,
};

export const iconsAsset = {
  "Key People": KeyPeople16,
  "Internal Application": InternalApplication16,
  "External Application": ExternalApplication16,
  "Sensitive Data": SensitiveData16,
  Other: AssetsIcon,
  DomainControllerIcon,
  AssetsServerIcon,
  AssetsUserIcon,
  EndpointIcon,
  EntitiesIcon,
};

export const logos = {
  AddigyLogo,
  AMILogo,
  AWSLogo,
  AsanaLogo,
  CatoLogo,
  CarbonBlackLogo,
  CheckmarxLogo,
  CheckpointHarmonyLogo,
  CheckpointQuantumLogo,
  CircleCILogo,
  CloudflareLogo,
  DigLogo,
  SentraLogo,
  OxLogo,
  BitwardenLogo,
  BoxLogo,
  PaloAltoCortexLogo,
  CrowdStrikeLogo,
  CursorLogo,
  CyberArkLogo,
  CoralogixLogo,
  BreezeLogo,
  FortinetLogo,
  GitHubLogo,
  GitLabLogo,
  GoogleLogo,
  HiBobLogo,
  ImpervaWAFLogo,
  ClaudeLogo,
  IntuneLogo,
  JamfLogo,
  JamfProtectLogo,
  JiraLogo,
  IruLogo,
  MicrosoftDefenderEndpoint,
  MicrosoftEntraIDLogo,
  MicrosoftOffice365Logo,
  MicrosoftSCCMLogo,
  MicrosoftTeamsLogo,
  MicrosoftAzureCloudLogo,
  MicrosoftActiveDirectoryLogo,
  AzureVMLogo,
  MongoAtlasLogo,
  NetskopeLogo,
  NetsuiteLogo,
  OktaLogo,
  OrcaLogo,
  OpenAILogo,
  PaloAltoPrismaLogo,
  ProofpointLogo,
  MimecastLogo,
  AbnormalLogo,
  QualysLogo,
  Rapid7Logo,
  SalesForceLogo,
  SentinelOneLogo,
  ServiceNowLogo,
  SlackLogo,
  SnowflakeLogo,
  SnykLogo,
  StarburstLogo,
  TenableLogo,
  TorqLogo,
  TwingateLogo,
  WizLogo,
  WorkatoLogo,
  ZendeskLogo,
  ZscalerLogo,
  S3Logo,
  ESCLogo,
  RDSLogo,
  LambdaLogo,
  ECSLogo,
  EC2Logo,
  WorkspaceLogo,
  EKSLogo,
  DynamodbLogo,
  MacIcon,
  WindowsIcon,
  LinuxIcon,
  NetwareIcon,
  RedhatIcon,
  MobileIcon,
  AkamaiWAFLogo,
  SecurityScorecard,
  PerceptionPoint,
  GCPLogo,
  PrismaAccessBrowserLogo,
  AzureSqlDBLogo,
  SplunkCloudLogo,
  SumoLogicLogo,
  BambooHRLogo,
  PanoraysLogo,
  GreenhouseLogo,
  CloseIcon,
  AxurLogo,
  VeeamLogo,
  CommvaultLogo,
  VaronisLogo,
  DruvaLogo,
  RubrikLogo,
  CyeraLogo,
  AdobeLogo,
  FigmaLogo,
  DocusignLogo,
  HubspotLogo,
  MiroLogo,
  ZoomLogo,
  NotionLogo,
  OneTrustLogo,
  MondayLogo,
  AtlassianLogo,
  JumpCloudLogo,
  NISTLogo,
  NinjaOneLogo,
  LayerXLogo,
  OpenVPNLogo,
  SilverfortLogo,
  ChatGptLogo,
  DeepSeekLogo,
  GeminiLogo,
};

export const severities = {
  MinimalSeverityIcon,
  LowSeverityIcon,
  MediumSeverityIcon,
  HighSeverityIcon,
  CriticalSeverityIcon,
  SeveritySuccessIcon,
  OutlineSeverity,
  SeverityBlueIcon,
  SeverityBlackIcon,
  SeverityErrorIcon,
  SeverityBackgroundSuccessIcon,
  SeverityBackgroundInfoIcon,
  SeverityBackgroundWarningIcon,
  SeverityWarningType2Icon,
  SeverityInfoTooltipIcon,
};

export const jiraPriorities = {
  TriageIcon,
  HighestIcon,
  HighIcon,
  MediumIcon,
  LowIcon,
  LowestIcon,
};

export const detectionIcons = {
  DetectionRed,
  DetectionBlack,
};

export const entityRisk = {
  CRITICAL: CriticalSeverityIcon,
  HIGH: HighSeverityIcon,
  MEDIUM: MediumSeverityIcon,
  LOW: LowSeverityIcon,
  MINIMAL: "Minimal",
};

export const sidebarIcons = {
  UserAccessIcon,
  UserPermissionsIcon,
  ControlsIcon,
  MitreIcon,
  ScenariosIcon,
  StepsIcon,
  VulnerabilitiesIcon,
  MatrixIcon,
  RemediationPlanIcon,
  TrackingIcon,
  AccountCenterIcon,
  SettingCenterIcon,
  AssetsIcon,
  EnvironmentIcon,
  IntegrationsIcon,
  DashboardIcon,
  AutomationIcon,
  PlaybookIcon,
  AdminPermissionsIcon,
  ExpandIcon,
  CollapseIcon,
  LogoCollapsed,
  LogoExpanded,
  OktaSSOIcon,
  NotificationsIcon,
  SecOpIcon,
  CloudIcon,
  InboxIcon,
  WorkflowsIcon,
  FrameworkIcon,
  AIIcon,
};
export const operationalHeatmap = {
  Mac: MacIcon,
  Windows: WindowsIcon,
  Linux: LinuxIcon,
  Mobile: MobileIcon,
  Server: ServerIcon,
  Serverless: ServerlessIcon,
  Container: ContainerIcon,
  Database: DatabaseIcon,
  "Analytical Data Storage": AnalyticalDataStorageIcon,
  "Cloud Storage": StorageIcon,
  "Email & Communications": EmailIcon,
  "Productivity Tools": ProductivityIcon,
  "File Sharing": FileSharingIcon,
  "Application Development": DevelopmentIcon,
  "IdP/Central Identity Directory": IdentityIcon,
  "API Keys & Tokens": ApiIcon,
  Secrets: SecretsIcon,
  "Service Accounts": ServiceAccountsIcon,
  "Edge Compute": EdgeComputeIcon,
};

export const inputIcons = {
  infoIcon,
  successIcon,
  errorIcon,
  PrimaryInfoIcon,
};
export const chartIcons = {
  BarChartIcon,
  HeatmapChartIcon,
  PieChartIcon,
  DonutChartIcon,
  GaugeChartIcon,
  TableChartIcon,
  MetricsChartIcon,
  StackedBarChartIcon,
  LineChartIcon,
  TwoLineChartIcon,
};

export const controlsCategory = {
  AI: AICategoryIcon,
  DLP: DLPCategoryIcon,
  EDR: EDRCategoryIcon,
  MFA: MFACategoryIcon,
  NHI: NHIcategoryIcon,
  "Zero Trust": ZeroTrustCategoryIcon,
  Email: EmailCategoryIcon,
};

export const workflowsIcons = {
  security: HighSeverityIcon,
  threat: AssetAttackerIcon,
  detection: DetectionRed,
  inventory: AssetsBlueIcon,
  asset: AssetsBlueIcon,
  severity: HighSeverityIcon,
  tool: JiraLogo,
  assignment: AssigneeIcon,
  time: DetectionRed,
  ticketing: JiraLogo,
  notification: SlackLogo,
  integration: DetectionRed,
  escalated: TrendUpIcon,
  gap_compliant: ControlStatusCompliantIcon,
  gap_discovered: ControlStatusGapIcon,
  snoozed: SnoozedIcon,
  snoozed_expired: UnsnoozedIcon,
  RandomWorkflowIcon: RandomWorkflowIcon,
};

export const workflowsConditionsIcons = {
  When: WorkflowWhenIcon,
  If: WorkflowIfIcon,
  Then: WorkflowThenIcon,
};

export const AIIntegrationsIcons = {
  cursor: CursorLogo,
  chatgpt: ChatGptLogo,
  claude: ClaudeLogo,
  gemini: GeminiLogo,
  deepseek: DeepSeekLogo,
  copilot: OpenAILogo,
};
